import React, { ReactElement } from 'react';
import { LinkTagsProps } from '../types';

export const LinkTags = ({ seo, config }: LinkTagsProps): (ReactElement | null)[] => {
  const domainUrl = config?.domainUrl;
  const canonical = seo?.canonical || '';
  const hasDomain = canonical.indexOf(domainUrl) !== -1;
  const linkTags = [{ rel: 'canonical', href: hasDomain ? seo.canonical : `${domainUrl}${canonical}` }];

  return linkTags.map(linkTag => <link key={linkTag.rel} {...linkTag} />);
};
